<!-- Bid Details Modal -->
<div
  class="modal-overlay"
  [class.active]="isActive" 
  (click)="closeModal()">
  <div class="modal bid-details-modal" (click)="$event.stopPropagation()">
    <button class="close-modal" (click)="closeModal()">x</button>
    
    <div class="bid-details-content" *ngIf="bid">
      <div class="modal-title-row">
        <h2 class="modal-title">Review bid details</h2>
        <button
          type="button"
          class="copy-bid-link-btn"
          [class.copied]="bidLinkCopied"
          (click)="onCopyBidDetailLink($event)"
          [attr.aria-label]="bidLinkCopied ? 'Link copied' : 'Copy link to this bid'"
          tippy
          [options]="{ content: bidLinkCopied ? 'Copied!' : 'Copy bid page link', placement: 'bottom', theme: 'punks' }">
          <svg *ngIf="!bidLinkCopied" xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <path d="M13.19 8.688a4.5 4.5 0 0 1 1.242 7.244l-4.5 4.5a4.5 4.5 0 0 1-6.364-6.364l1.757-1.757m13.35-.622 1.757-1.757a4.5 4.5 0 0 0-6.364-6.364l-4.5 4.5a4.5 4.5 0 0 0 1.242 7.244"/>
          </svg>
          <svg *ngIf="bidLinkCopied" xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <path d="M20 6 9 17l-5-5"/>
          </svg>
        </button>
      </div>
      
      <div class="bid-description">
        <p>
          This bid is offered by 
          <a [routerLink]="['/', 'user', bid.bidder_address]" class="bidder-address-highlight">
            <app-wallet-address [address]="bid.bidder_address"></app-wallet-address>
          </a>
        </p>
      </div>
      
      <div class="bid-info-section tags-section">
        <div class="info-label">Bid Type & Tags</div>
        <div class="bid-tags-content">
          <div *ngIf="bid.confidential" class="confidential-pill" title="Confidential bid">
            <svg style="transform: scale(1.4);" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px"><path d="M480-320q75 0 127.5-52.5T660-500q0-75-52.5-127.5T480-680q-75 0-127.5 52.5T300-500q0 75 52.5 127.5T480-320Zm0-72q-45 0-76.5-31.5T372-500q0-45 31.5-76.5T480-608q45 0 76.5 31.5T588-500q0 45-31.5 76.5T480-392Zm0 192q-146 0-266-81.5T40-500q54-137 174-218.5T480-800q146 0 266 81.5T920-500q-54 137-174 218.5T480-200Zm0-300Zm0 220q113 0 207.5-59.5T832-500q-50-101-144.5-160.5T480-720q-113 0-207.5 59.5T128-500q50 101 144.5 160.5T480-280Z"/></svg>
            <span>Confidential</span>
          </div>
          <div
            *ngIf="bid.stash_funded === 0"
            class="unfunded-pill"
            title="Stash balance is below this bid amount">
            unfunded
          </div>
          <span
            class="bid-type-pill"
            [class.trait]="bid.bidType === 'trait'"
            [class.custom]="bid.bidType === 'custom'"
            [class.owner]="bid.bidType === 'owner'"
            [class.collection]="bid.bidType === 'collection'"
            [class.legacy]="bid.bidType === 'legacy' || bid.isLegacyBid"
            [class.punksmarket]="bid.bidType === 'punksmarket' || isPunksmarketBid">
            {{ bid.bidTypeLabel || (isPunksmarketBid ? onChainBidTypeLabel : bid.bidType === 'trait' ? 'Trait Bid' : bid.bidType === 'owner' ? 'Owner Bid' : bid.bidType === 'custom' ? 'Custom Bid' : bid.bidType === 'legacy' || bid.isLegacyBid ? nativeBidTypeLabel : 'Collection Bid') }}
            <app-on-chain-bid-info-icon
              *ngIf="isPunksmarketBid"
              [iconSize]="14"
              [insetInPill]="true" />
          </span>
          <ng-container *ngIf="bid.bidType === 'owner' && bid.ownerAddress">
            <div class="tags-list">
              <a class="tag-pill owner-link" [routerLink]="['/', 'user', bid.ownerAddress]">
                Owner: <app-wallet-address [address]="bid.ownerAddress"></app-wallet-address>
              </a>
            </div>
          </ng-container>
          <ng-container *ngIf="bid.bidType === 'custom' && bid.punkIndices && bid.punkIndices.length > 0">
            <div class="tags-list">
              <span class="tag-pill" *ngFor="let tag of bid.punkIndices">
                #{{ tag }}
              </span>
            </div>
          </ng-container>
          <ng-container *ngIf="bid.decodedTags?.length && bid.bidType !== 'custom' && bid.bidType !== 'owner'">
            <div class="tags-list">
              <span class="tag-pill" *ngFor="let tag of bid.decodedTags">{{ tag }}</span>
            </div>
          </ng-container>
        </div>
      </div>

      <div
        class="bid-info-section pm-criteria-section"
        *ngIf="isPunksmarketBid && punksmarketCriteriaLines.length && !loadingBidDetails">
        <div class="info-label">Matching criteria</div>
        <ul class="criteria-lines-list">
          <li *ngFor="let line of punksmarketCriteriaLines">{{ line }}</li>
        </ul>
        <div class="palette-swatches" *ngIf="punksmarketColorRefs.length">
          <span
            class="palette-swatch-item"
            *ngFor="let color of punksmarketColorRefs"
            [title]="'Palette id ' + color.id">
            <span class="palette-swatch" [style.background-color]="color.hex"></span>
            <span class="palette-swatch-label">{{ color.hex }} · {{ color.id }}</span>
          </span>
        </div>
        <p class="criteria-hint">
          Traits use the PunksData asset index (0–110). Colors use the sealed on-chain palette (1–221).
        </p>
      </div>
      
      <div class="bid-info-section">
        <div class="info-label">Amount in ETH</div>
        <div class="info-value">{{ bid.bid_amount_eth | number:'1.0-18' }}</div>
      </div>

      <div
        class="bid-info-section"
        *ngIf="isPunksmarketBid && punksmarketSettlementEth != null && punksmarketSettlementEth > 0">
        <div class="info-label">Settlement reward</div>
        <div class="info-value">{{ punksmarketSettlementEth | number:'1.0-18' }} ETH</div>
      </div>

      <div class="bid-info-section" *ngIf="isPunksmarketBid && punksmarketTxHash">
        <div class="info-label">Placement transaction</div>
        <a
          class="info-value tx-link"
          [href]="'https://etherscan.io/tx/' + punksmarketTxHash"
          target="_blank"
          rel="noopener noreferrer">
          {{ punksmarketTxHash | slice:0:10 }}…{{ punksmarketTxHash | slice:-8 }}
        </a>
      </div>

      <button
        *ngIf="!bid.isLegacyBid && bid.bidType !== 'legacy' && !isPunksmarketBid"
        class="close-btn copy-bid-btn"
        (click)="onCopyBid()">
        {{ cloneBidLabel }}
      </button>
      
      <div *ngIf="!loadingBidDetails">
        <div class="info-label punks-label" *ngIf="selectedBidPunkIds.length > 0 || bidDetailsError || (isPunksmarketBid && punksmarketTargetKind === 'any')">
          <span *ngIf="selectedBidPunkIds.length > 0">{{ selectedBidPunkIds.length }} targeted CryptoPunk{{ selectedBidPunkIds.length === 1 ? '' : 's' }}</span>
          <span *ngIf="selectedBidPunkIds.length === 0 && !bidDetailsError && isPunksmarketBid && punksmarketTargetKind === 'criteria'">Matches by criteria (not a fixed punk list)</span>
          <span *ngIf="selectedBidPunkIds.length === 0 && !bidDetailsError && (!isPunksmarketBid || punksmarketTargetKind === 'any')">All CryptoPunks</span>
        </div>
        <div class="error-message" *ngIf="bidDetailsError">
          {{ bidDetailsError }}
        </div>
        <div class="punks-grid" *ngIf="displayedPunkIds.length > 0">
          <div 
            *ngFor="let punkId of displayedPunkIds; let i = index"
            class="punk-item">
            <img
              [lazyLoad]="dataSvc.staticUrl + dataSvc.tokenImagePath + (punkId | tokenIdParse) + '.svg'"
              [defaultImage]="environment.collection === 'cryptophunks' ? 'assets/loadingphunk.png' : 'assets/loadingpunk.png'"
              [alt]="'Punk #' + punkId"
              class="punk-image"
            />
          </div>
        </div>
        <button
          type="button"
          class="view-all-punks-btn"
          *ngIf="selectedBidPunkIds.length > 14 && !viewAllPunks"
          (click)="toggleViewAllPunks()">
          View all ({{ selectedBidPunkIds.length }} punks)
        </button>
        <button
          type="button"
          class="view-all-punks-btn"
          *ngIf="viewAllPunks"
          (click)="toggleViewAllPunks()">
          Show less
        </button>
        <div class="all-punks-message" *ngIf="selectedBidPunkIds.length === 0 && !bidDetailsError && punksmarketTargetKind !== 'criteria'">
          This bid applies to all CryptoPunks in the collection.
        </div>
        <div class="all-punks-message criteria-only-message" *ngIf="selectedBidPunkIds.length === 0 && !bidDetailsError && punksmarketTargetKind === 'criteria'">
          Matching punks are determined by the on-chain criteria above, not a fixed allowlist.
        </div>
      </div>
      <div class="bid-info-section loading-section" *ngIf="loadingBidDetails">
        <div class="loader-wrapper">
          <app-loader></app-loader>
          <p class="loading-text">Loading bid details...</p>
        </div>
      </div>
      
      <div class="bid-info-section expires-section" *ngIf="bid.expires_at">
        <div class="info-label">Expires on</div>
        <div class="info-value expires-value">{{ bid.expires_at | date:'MMM d, y, h:mm:ss a z' }}</div>
      </div>
      
      <button class="close-btn" (click)="closeModal()">Close</button>
    </div>
  </div>
</div>
